<template>
    <transition name="fade" @after-leave="destroy">
        <div :class="['toast', { error }]" @click="close" v-show="active">
            {{ message }}
        </div>
    </transition>
</template>

<script>
export default {
  name: 'Toast',

  data() {
    return {
      active: false,
      bottom: null,
      message: '',
      timeout: 5000,
      timer: null,
      triggerClose: null,
      error: false,
    };
  },

  mounted() {
    this.timer = setTimeout(() => {
      this.close();
    }, this.timeout);
  },

  methods: {
    close() {
      this.active = false;
      this.triggerClose();
    },

    destroy() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.toast {
  @include prevent-select;
  box-shadow: $drop-shadow-2;
  background-color: $secondary-color;
  color: $white-color;
  border-radius: $border-radius;
  padding: $gp * 1.5;
  margin-top: $gp;
  z-index: $zindex-toast;

  &.error {
    background-color: $error-color;
  }
}
</style>
